import { RocketLaunchIcon } from '@heroicons/react/24/outline';

import SecaoDefaultSimOuNao from './SecaoDefaultSimOuNao';

const SecaoInteresseOutrasAreas = ({ colaborador, isLoading }) => {
  return (
    <SecaoDefaultSimOuNao
      isLoading={isLoading}
      icon={RocketLaunchIcon}
      titleId="interesseOutrasAreas"
      value={colaborador?.interesseOutrasAreas}
      detailsList={colaborador?.areasInteresse}
    />
  );
};

export default SecaoInteresseOutrasAreas;
